import React from "react";
import { Typography } from "@mui/material";
import MessageThreadList from "./MessageThreadList";

import { Box, Stack } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import useAppSelectors from "../../../customHooks/useAppSelectors";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const MessageThreadDrawer = ({
  setMessageThreadOpen,
  setMediaFilesOpen,
  setReplyParentMsg,
  handlegetThreadMessages,
  handleBacktoMessage,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  setisTopicOpen,
  handleReadStatusDrawer,
  handleSendTempMsg,
  handleClickTaskUpdate,
  isTopicOpen,
  progress,
  isSearchGroupInfoOpen,
  handleSearch,
  handleAddgroupMember,
  isPrivateChatOn,
  searchInputValue,
  handleSearchInputChange,
  highlightText,
  filteredMessageList,
  chatInputControl,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { selectedGroup, messageList } = useAppSelectors();

  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setMessageThreadOpen(false)}
            />
          </Typography>
          <Typography color={"black"}>Message Thread</Typography>
        </Stack>
      </Stack>

      <Box>
        <Box padding="0px 19px 0px 12px">
          <Typography variant="caption" color={"black"}>
            {appContent?.KEY251}
          </Typography>

          <Box sx={{height:"73vh"}}>
            <MessageThreadList
              messageList={selectedGroup ? messageList : []}
              setMediaFilesOpen={setMediaFilesOpen}
              setReplyParentMsg={setReplyParentMsg}
              handlegetThreadMessages={handlegetThreadMessages}
              handleBacktoMessage={handleBacktoMessage}
              setMoveTopicTriggered={setMoveTopicTriggered}
              setMoveTopicMsgId={setMoveTopicMsgId}
              setisTopicOpen={setisTopicOpen}
              handleReadStatusDrawer={handleReadStatusDrawer}
              handleSendTempMsg={handleSendTempMsg}
              handleClickTaskUpdate={handleClickTaskUpdate}
              isTopicOpen={isTopicOpen}
              progress={progress}
              isSearchGroupInfoOpen={isSearchGroupInfoOpen}
              handleSearch={handleSearch}
              handleAddgroupMember={handleAddgroupMember}
              isPrivateChatOn={isPrivateChatOn}
              searchInputValue={searchInputValue}
              handleSearchInputChange={handleSearchInputChange}
              highlightText={highlightText}
              filteredMessageList={filteredMessageList}
            />
          </Box>

          <Box>{chatInputControl({hideSuggestBtn:false})}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MessageThreadDrawer;
